import React from "react";

const Text = ({value, ...others}) => {
    return (
        <div {...others} dangerouslySetInnerHTML={{__html: value}} />
    )
}

export default Text;